// This is a simple functional component for displaying a feature item.
// It takes in an icon, title, and description as props and renders them in a styled container.
import React from 'react';
import styles from './FeatureItem.module.css'; // Adjust the path as necessary
function FeatureItem({ icon, title, description }) {
  return (
    <div className={styles.featureItem}>
      <div className={styles.featureIcon}>{icon}</div>
      <h4 className={styles.featureTitle}>{title}</h4>
      <p className={styles.featureDescription}>{description}</p>
    </div>
  );
}

export default FeatureItem;
